<template>
    <div class="home-page">
		<Header></Header>
		<div class="mission" v-if="!notFound">
      <div class="mission-content">
        <div class="myPoints-list">
          <div class="myPoints-ul">
            <div class="mission-t" style="font-size:52px;">
              {{$t('myPoints')}}
            </div>
            <div class="myPoints-ul-scrool">
              <div class="fen myPoints-fen">{{score}}</div>
              <div class="mt50 ac">{{$t('redeemTips2')}}</div>
            </div>
          </div>
          <div class="fen title-bg mt50" style="width: 50%;margin:80px auto 40px;">{{$t('pointHistory')}}</div>
          <div class="point-history">
            <div class="point-t ac disflex">
              <span class="point-one1">{{$t('time')}}</span>
              <span class="point-one2">{{$t('description')}}</span>
              <span class="point-one3">{{$t('points')}}</span>
            </div>
            <div class="point-c">
              <div class="point-li ac disflex" v-for="(item,index) in list">
                <span class="point-one1">{{item.day}}</span>
                <span class="point-one2">{{item.remark}}</span>
                <span class="point-one3">{{item.score}}</span>
              </div>
            </div>
          </div>
          <div class="more mt50 ac crfff" @click="getMore" v-if="isShow">{{noMore}}</div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page:1,
			limit:5,
      score:'',
			isShow:'All',
      listMenu:['All','action','adventure','puzzle','sports'],
      noMore:''
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/index'})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {
				page:that.page,
				limit:that.limit,
			}
			that.$api.post('/api/point/index',data,r =>{
				that.$parent.returnCode(r,function(){
					//that.list = r.data.list
					that.score = r.data.score
					that.$parent.loadModal(false);
					if(r.data.list.length>0){
						that.list = that.list.concat(r.data.list)
            console.log(that.list)
					}else{
						that.isShow = false;
						that.$utils.alertText(that.$t('noMore'));
					}

       });

			})
		},
		getMore(){
			let that = this;
			if(that.isShow){
				that.page++;
				that.getHome();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/myPoints.vue